import { alpha, Box } from "@mui/material";
import BasicTooltip from "src/components/BasicTooltip";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import { ASSETS_COLORS } from "src/theme/palette";
import { ActionTypeDict } from "src/utils/actionTypes";

interface Props {
	type: string;
	size?: number;
}

const sx = {
	p: 1,
	display: "flex",
	borderRadius: 1
};

export default function IconType({ type, size = 20 }: Props) {
	const { translate } = useLocales();

	let color = ASSETS_COLORS.black;
	let icon = ActionTypeDict.UNKNOWN.icon;

	if (ActionTypeDict[type]?.color) {
		color = ASSETS_COLORS[ActionTypeDict[type].color];
		icon = ActionTypeDict[type].icon;
	}

	return (
		<Box bgcolor={alpha(color.main, 0.16)} sx={sx}>
			<BasicTooltip title={translate(`demo.${type}`)}>
				<Iconify color={color.main} height={size} icon={icon} width={size} />
			</BasicTooltip>
		</Box>
	);
}
